import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostProvidersList,
	PostProvidersListModel,
	PostProvidersListParams,
} from 'domain/usecases/private/authorizations/post-providers-list';

export class RemotePostProvidersList implements PostProvidersList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostProvidersListModel>,
	) {}

	async post(params: PostProvidersListParams): Promise<PostProvidersListModel> {
		const {signal, ...restParams} = params || {};

		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: restParams,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
